import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';

import tpl from './message-template.hbs';

function parseHTML(elm) {
  return $('<div/>').html(elm).html();
}

export var MessageView = Backbone.View.extend({
  el: '.app__message',

  template: tpl,

  initialize: function () {
    _.bindAll(this, 'onButtonClicked');
    this.listenTo(this.model, 'change:isVisible', this.render);
  },

  events: {
    'click .message-popup__btn': 'onButtonClicked'
  },

  render: function () {
    var cloned = _.clone(this.model.attributes);
    var message = cloned.message;
    var wrappedMsg = [];

    if (message instanceof $) {
      // 태그로 감싸지 않고 message 값을 그대로 노출
      wrappedMsg.push(parseHTML(message));
    } else {
      if (_.isString(message)) {
        wrappedMsg.push('<p>' + message + '</p>');
      } else if (_.isArray(message)) {
        wrappedMsg = _.map(message, function (line) {
          return '<p>' + line + '</p>';
        });
      }
      if (wrappedMsg.length === 1) {
        wrappedMsg.push('<p class="blank"></p>');
      }
    }

    var context = _.extend(cloned, { message: wrappedMsg.join('') });
    this.$el.html(this.template(context));

    var $popCon = this.$el.find('.message-popup__container');
    $popCon.css({
      'margin-left': $popCon.outerWidth() / -2,
      'margin-top': $popCon.outerHeight() / -2
    });

    return this;
  },

  onButtonClicked: function (e) {
    e.preventDefault();

    var clicked = $(e.currentTarget).data('callback');
    var cb = this.model.get(clicked);

    if (_.isFunction(cb)) {
      cb.call();
    }

    this.model.hide();
  }
});
